var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      model: {
        value: _vm.isFormValid,
        callback: function($$v) {
          _vm.isFormValid = $$v
        },
        expression: "isFormValid"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "mb-12 pt-2 float-remover", attrs: { color: "white" } },
        [
          _c(
            "v-row",
            [
              this.$vuetify.breakpoint.lgAndUp
                ? _c(
                    "v-col",
                    {
                      staticClass: "d-flex justify-center align-center",
                      attrs: { md: "5", sm: "12" }
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "mx-auto card-option fill-height",
                          attrs: { color: "grey lighten-4", "full-width": "" }
                        },
                        [
                          _c("v-img", {
                            staticClass: "white--text align-end fill-height",
                            attrs: {
                              src: require("@/assets/tickets-r3-datacenter-access.png")
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { attrs: { md: "7", sm: "12" } },
                [
                  _c("div", { staticClass: "font-weight-light" }, [
                    _c(
                      "p",
                      [
                        _c("v-icon", [_vm._v("mdi-account-arrow-right")]),
                        _c("span", { staticClass: "mx-1" }, [
                          _vm._v("Razones de acceso:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.textForAllValues(
                                _vm.accessTicket.generalInformation
                                  .accessReasons,
                                "reasons"
                              )
                            ) +
                            " "
                        )
                      ],
                      1
                    ),
                    !_vm.stringIsUndefined(
                      _vm.accessTicket.generalInformation.emergencyChangeReason
                    )
                      ? _c("p", [
                          _c("span", { staticClass: "font-weight-regular" }, [
                            _vm._v("Razón del cambio de emergencia: ")
                          ]),
                          _vm._v(
                            _vm._s(
                              _vm.accessTicket.generalInformation
                                .emergencyChangeReason
                            ) + " "
                          )
                        ])
                      : _vm._e(),
                    !_vm.stringIsUndefined(
                      _vm.accessTicket.generalInformation.orderNumber
                    )
                      ? _c("p", [
                          _c("span", { staticClass: "font-weight-regular" }, [
                            _vm._v("Número de orden: ")
                          ]),
                          _vm._v(
                            _vm._s(
                              _vm.accessTicket.generalInformation.orderNumber
                            ) + " "
                          )
                        ])
                      : _vm._e(),
                    _c(
                      "p",
                      [
                        _c("v-icon", [_vm._v("mdi-calendar")]),
                        _c("span", { staticClass: "mx-1" }, [
                          _vm._v("Fechas de acceso:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.setLongFormatDate(
                                _vm.accessTicket.generalInformation.fromDateVal
                              )
                            ) +
                            " a las " +
                            _vm._s(
                              _vm.formatTime(
                                _vm.accessTicket.generalInformation.fromTimeVal
                              )
                            ) +
                            " - " +
                            _vm._s(
                              _vm.setLongFormatDate(
                                _vm.accessTicket.generalInformation.toDateVal
                              )
                            ) +
                            " a las " +
                            _vm._s(
                              _vm.formatTime(
                                _vm.accessTicket.generalInformation.toTimeVal
                              )
                            ) +
                            " "
                        )
                      ],
                      1
                    ),
                    _c(
                      "p",
                      [
                        _c("v-icon", [_vm._v("mdi-map-marker")]),
                        _c("span", { staticClass: "mx-1" }, [
                          _vm._v("Sede a visitar:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.textForValue(
                                _vm.accessTicket.generalInformation
                                  .headquarters,
                                "dataCenters"
                              )
                            ) +
                            " "
                        )
                      ],
                      1
                    ),
                    _c(
                      "p",
                      [
                        _c("v-icon", [_vm._v("mdi-account-tie")]),
                        _vm._v("Autorizado(s): "),
                        _vm._l(
                          _vm.accessTicket.involvedPeople.authorizedPeople,
                          function(authorizedPerson, index) {
                            return _c(
                              "span",
                              { key: authorizedPerson.idNumber },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(authorizedPerson.firstName) +
                                    " " +
                                    _vm._s(authorizedPerson.lastName) +
                                    " "
                                ),
                                index !=
                                _vm.getLength(
                                  _vm.accessTicket.involvedPeople
                                    .authorizedPeople
                                ) -
                                  1
                                  ? _c("span", [_vm._v(", ")])
                                  : _vm._e()
                              ]
                            )
                          }
                        )
                      ],
                      2
                    ),
                    _vm.getLength(
                      _vm.accessTicket.involvedPeople.additionalPeople
                    ) > 0
                      ? _c(
                          "p",
                          [
                            _c("v-icon", [_vm._v("mdi-account-group")]),
                            _c("span", { staticClass: "mx-1" }, [
                              _vm._v("Involucrado(s):")
                            ]),
                            _vm._l(
                              _vm.accessTicket.involvedPeople.additionalPeople,
                              function(additionalPeople, index) {
                                return _c(
                                  "span",
                                  { key: additionalPeople.idNumber },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(additionalPeople.firstName) +
                                        " " +
                                        _vm._s(additionalPeople.lastName) +
                                        " "
                                    ),
                                    index !=
                                    _vm.getLength(
                                      _vm.accessTicket.involvedPeople
                                        .additionalPeople
                                    ) -
                                      1
                                      ? _c("span", [_vm._v(", ")])
                                      : _vm._e()
                                  ]
                                )
                              }
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.getLength(_vm.accessTicket.accessCars)
                      ? _c(
                          "p",
                          [
                            _c("v-icon", [_vm._v("mdi-car")]),
                            _c("span", { staticClass: "mx-1" }, [
                              _vm._v("Vehículos de acceso:")
                            ]),
                            _vm._l(_vm.accessTicket.accessCars, function(
                              car,
                              index
                            ) {
                              return _c("span", { key: car.numberPlate }, [
                                _vm._v(" " + _vm._s(car.numberPlate) + " "),
                                index !=
                                _vm.getLength(_vm.accessTicket.accessCars) - 1
                                  ? _c("span", [_vm._v(", ")])
                                  : _vm._e()
                              ])
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _c("p", [
                      _vm.getLength(_vm.getClientTasks)
                        ? _c(
                            "span",
                            [
                              _c("v-icon", [_vm._v("mdi-playlist-plus")]),
                              _c("span", { staticClass: "mx-1" }, [
                                _vm._v("Tareas:")
                              ]),
                              _vm._l(_vm.getClientTasks, function(task, index) {
                                return _c("span", { key: task.description }, [
                                  _vm._v(" " + _vm._s(task.description) + " "),
                                  index != _vm.getLength(_vm.getClientTasks) - 1
                                    ? _c("span", [_vm._v(", ")])
                                    : _vm._e()
                                ])
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.getLength(_vm.getDaycoTasks) > 0 &&
                      _vm.getLength(_vm.getClientTasks) > 0
                        ? _c("span", [_vm._v(" y ")])
                        : _vm._e(),
                      _vm.getLength(_vm.getDaycoTasks)
                        ? _c("span", [
                            _vm._v(
                              " Tareas realizadas por el equipo de Daycohost "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm.getLength(_vm.accessTicket.hardwareTransfer.hardware)
                      ? _c(
                          "p",
                          [
                            _c("v-icon", [_vm._v("mdi-server")]),
                            _c("span", { staticClass: "mx-1" }, [
                              _vm._v("Equipos:")
                            ]),
                            _vm._l(
                              _vm.accessTicket.hardwareTransfer.hardware,
                              function(hardware, index) {
                                return _c(
                                  "span",
                                  { key: hardware.serialNumber },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(hardware.name) +
                                        " (" +
                                        _vm._s(hardware.serialNumber) +
                                        ") "
                                    ),
                                    index !=
                                    _vm.getLength(
                                      _vm.accessTicket.hardwareTransfer.hardware
                                    ) -
                                      1
                                      ? _c("span", [_vm._v(", ")])
                                      : _vm._e()
                                  ]
                                )
                              }
                            )
                          ],
                          2
                        )
                      : _vm._e()
                  ]),
                  _c(
                    "v-row",
                    { staticClass: "ma-3" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-0 ma-0",
                          attrs: { lg: "5", sm: "12" }
                        },
                        [
                          _c(
                            "v-chip",
                            {
                              attrs: {
                                label: "",
                                large: "",
                                color: "gray",
                                outlined: ""
                              },
                              on: { click: _vm.openPDT }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: { left: "", color: "blue lighten-1" }
                                },
                                [_vm._v("mdi-file")]
                              ),
                              _c("p", { staticClass: "caption ma-0" }, [
                                _vm._v("PERMISO-DE-ACCESO.pdf")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.requiresHardware && _vm.hasDepartingEquipments
                        ? _c(
                            "v-col",
                            {
                              staticClass: "pa-0 ma-0",
                              attrs: { lg: "5", sm: "12" }
                            },
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    label: "",
                                    large: "",
                                    color: "gray",
                                    outlined: ""
                                  },
                                  on: { click: _vm.openEquipmentSheet }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        left: "",
                                        color: "blue lighten-1"
                                      }
                                    },
                                    [_vm._v("mdi-file")]
                                  ),
                                  _c("p", { staticClass: "caption ma-0" }, [
                                    _vm._v("MOVIMIENTO-DE-EQUIPOS.pdf")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticClass: "float-right",
              attrs: { justify: "end", align: "center" }
            },
            [
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green", outlined: "" },
                      on: { click: _vm.reset }
                    },
                    [
                      _c(
                        "span",
                        { class: { caption: _vm.$vuetify.breakpoint.xsOnly } },
                        [_vm._v("Cancelar")]
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  class: { "mr-n3": _vm.$vuetify.breakpoint.xsOnly },
                  attrs: { cols: "4" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: "green", outlined: "" },
                      on: { click: _vm.previousStep }
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-chevron-left")]),
                      _c("span", { staticClass: "d-none d-sm-flex" }, [
                        _vm._v("Regresar")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: "green", loading: _vm.creatingTicket },
                      on: { click: _vm.sendAccessTicket }
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-check-all")]),
                      _c("span", [_vm._v("Enviar")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }